/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';

export class AuthLog extends JSONable {
    uuid: string | undefined = undefined
    userName: string | undefined = undefined;
    loginDate: Date | undefined = undefined;
    loginDateAndTime: Date | undefined = undefined;
    ipAddress: string | undefined = undefined;
    operatingSystem: string | undefined = undefined;
    browser: string | undefined = undefined;
}
